"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _elements = require("./elements");
var _icons = _interopRequireDefault(require("../attrs/icons"));
var _NotifyIcon = _interopRequireDefault(require("../NotifyIcon"));
var _excluded = ["children", "className", "name", "id", "label", "value", "size", "handleChange", "fullWidth", "withEmptyField", "margin", "required", "error", "helperText", "native", "disabled", "iconName"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var CustomSelect = function CustomSelect(_ref) {
  var children = _ref.children,
    className = _ref.className,
    name = _ref.name,
    id = _ref.id,
    label = _ref.label,
    value = _ref.value,
    size = _ref.size,
    handleChange = _ref.handleChange,
    fullWidth = _ref.fullWidth,
    withEmptyField = _ref.withEmptyField,
    margin = _ref.margin,
    required = _ref.required,
    error = _ref.error,
    helperText = _ref.helperText,
    _native = _ref["native"],
    disabled = _ref.disabled,
    iconName = _ref.iconName,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_elements.StyledSelectWrapper, {
    className: className,
    fullWidth: fullWidth,
    margin: margin,
    required: required,
    size: size,
    variant: "filled",
    error: error,
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(_material.InputLabel, {
    id: id
  }, label), /*#__PURE__*/_react["default"].createElement(_material.Select, _extends({
    "native": _native,
    inputProps: {
      IconComponent: function IconComponent() {
        return /*#__PURE__*/_react["default"].createElement(_NotifyIcon["default"], {
          className: "iconEnd",
          iconName: iconName || "chevronDown"
        });
      },
      name: name,
      id: "select-".concat(id)
    },
    value: value,
    onChange: handleChange,
    style: {
      minWidth: "150px"
    }
  }, props), withEmptyField && /*#__PURE__*/_react["default"].createElement("option", {
    "aria-label": "None",
    value: ""
  }), children), helperText && /*#__PURE__*/_react["default"].createElement(_material.FormHelperText, null, helperText));
};
CustomSelect.propTypes = {
  id: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string.isRequired,
  name: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string,
  handleChange: _propTypes["default"].func.isRequired,
  "native": _propTypes["default"].bool,
  fullWidth: _propTypes["default"].bool,
  withEmptyField: _propTypes["default"].bool,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  size: _propTypes["default"].string,
  margin: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  error: _propTypes["default"].bool,
  helperText: _propTypes["default"].string
};
CustomSelect.defaultProps = {
  className: '',
  value: "",
  fullWidth: false,
  size: "medium",
  withEmptyField: false,
  margin: "normal",
  "native": true,
  required: false,
  error: false,
  helperText: ""
};
var _default = exports["default"] = CustomSelect;